<template>
  <div class="about">
    <h1>This is an account page</h1>
    <Alert closable>mock 请求数据使用的 GET 方法</Alert>
    <Table height="700" stripe :columns="columns" :data="data"></Table>
  </div>
</template>

<script>
import { getAccountList } from '@/api/account';

export default {
  data() {
    return {
      columns: [
        {
          title: '账号ID',
          key: 'account_id',
          width: 120,
        },
        {
          title: '账号名',
          key: 'account_name',
          width: 180,
        },
        {
          title: '姓名',
          key: 'name',
          width: 90,
        },
        {
          title: '创建时间',
          key: 'create_time',
          width: 180,
        },
        {
          title: '详情',
          key: 'detail',
          width: 660,
        },
        {
          title: '个人印章',
          key: 'thumbnail',
          width: 100,
          render: (h, parameters) => {
            return h('div', [
              h(
                'a',
                {
                  attrs: {
                    href: parameters.row.thumbnail,
                  },
                  style: {
                    color: '#ff6600',
                  },
                },
                parameters.row.name,
              ),
            ]);
          },
        },
      ],
      data: [],
    };
  },
  methods: {
    requestData() {
      getAccountList().then((result) => {
        this.data = result.data;
      });
    },
  },
  mounted() {
    this.requestData();
  },
};
</script>
